import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const AwardedCard = ({ order }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-xl shadow-md border border-gray-200 mb-3"
    >
      {/* HEADER */}
      <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between">
        <p className="text-base font-semibold text-black">
          {order?.order_number}
        </p>
      </div>

      {/* BODY */}
      <div className="px-5 py-6 flex flex-col items-center">

        {/* Icon */}
        <motion.div
          initial={{ opacity: 0, scale: 0.7 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3, duration: 0.25 }}
          className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-3"
        >
          <FontAwesomeIcon icon={faCheckCircle} size="40px" color="#16a34a" />
        </motion.div>

        {/* Title */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.25 }}
          className="text-lg font-bold text-green-700"
        >
          Order Confirmed
        </motion.p>

        {/* Subtitle (Optional, uncomment if needed) */}
        {/*
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.3 }}
          className="flex flex-row items-center justify-center mt-2"
        >
          <div className="flex flex-row items-center bg-gray-50 px-2 py-1 rounded-lg border border-gray-200">
            <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
            <p className="text-xs text-gray-600">Source:</p>
            <p className="text-blue-600 font-bold ml-1 text-sm">RFQ-0019</p>
          </div>
        </motion.div>
        */}
      </div>
    </motion.div>
  );
};

export default AwardedCard;
